import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

import {
  formatShortDate,
  getStartDateFormatter,
  formatShortAddress,
  sort,
  getTimezoneDate,
  timezones,
} from './../../../../utilities/helpers'

import Card from 'react-bootstrap/Card'
import Row from 'react-bootstrap/Row'

import './teamCardBody.scss'

export default function TeamCardBody({ organization }) {
  const homeVenue = organization?.homeVenue
  const upcomingEvents = organization?.upcomingEvents || []

  return (
    <Fragment>
      <Card.Title as="h5">{organization?.name}</Card.Title>
      {homeVenue?.address?.length > 0 && (
        <Card.Text as="p">{formatShortAddress(homeVenue)}</Card.Text>
      )}
      <hr />
      <ul className="venue-list">
        {sort(upcomingEvents).map((event, index) => {
          const timezone = timezones(event?.venue?.timezone)

          return (
            <li key={event?.uuid || index}>
              <Row>
                <span className="col caption">
                  {formatShortDate(
                    getTimezoneDate(event?.start, timezone),
                    getStartDateFormatter(event)
                  )}
                </span>
                <span className="col caption caption-bold text-end">
                  {event?.name}
                </span>
              </Row>
            </li>
          )
        })}
      </ul>
      <Card.Link
        as={Link}
        to={`/${organization?.slug}`}
        className="btn btn-outline-light text-primary btn-sm"
      >
        View All
      </Card.Link>
    </Fragment>
  )
}
